import { useState } from 'react';
import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const Contact = ({ isVisible }) => {
  const [formState, setFormState] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState('submitting');
    setErrorMessage('');

    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      company: formData.get('company'),
      message: formData.get('message'),
    };

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      if (result.success) {
        setFormState('success');
        e.target.reset();
      } else {
        setErrorMessage(result.error || 'Something went wrong.');
        setFormState('error');
      }
    } catch {
      setErrorMessage('Unable to send message. Please try again later.');
      setFormState('error');
    }
  };

  return (
    <Section
      id="contact"
      alt
      isVisible={isVisible}
      title={<>Start the <span style={{ color: COLORS.cantaloupe }}>Conversation</span></>}
      subtitle={siteContent.contact.subtitle}
    >
      <div className="max-w-4xl mx-auto">
        <Card>
          {formState === 'success' ? (
            <div className="text-center py-12">
              <div className="text-5xl mb-4" style={{ color: COLORS.teal }}>✓</div>
              <h3 className="text-2xl font-bold mb-2" style={{ color: COLORS.navy }}>Message Sent</h3>
              <p style={{ color: COLORS.slate }}>Thank you for your message. We will be in touch shortly.</p>
              <button
                onClick={() => setFormState('idle')}
                className="mt-6 px-6 py-2 rounded-lg font-medium transition-all"
                style={{ color: COLORS.cantaloupe, border: `1px solid ${COLORS.cantaloupe}` }}
              >
                Send another message
              </button>
            </div>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              {formState === 'error' && (
                <div className="p-4 rounded-lg text-center" style={{ backgroundColor: 'rgba(239,68,68,0.1)', color: '#DC2626' }}>
                  {errorMessage}
                </div>
              )}

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: COLORS.navy }}>Name</label>
                  <input
                    type="text" name="name" required
                    className="w-full px-4 py-3 rounded-lg transition-all"
                    style={{ backgroundColor: 'white', border: '1px solid #CBD5E1', color: COLORS.navy }}
                    placeholder="Your full name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: COLORS.navy }}>Email</label>
                  <input
                    type="email" name="email" required
                    className="w-full px-4 py-3 rounded-lg transition-all"
                    style={{ backgroundColor: 'white', border: '1px solid #CBD5E1', color: COLORS.navy }}
                    placeholder="your.email@company.com"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: COLORS.navy }}>Company</label>
                <input
                  type="text" name="company"
                  className="w-full px-4 py-3 rounded-lg transition-all"
                  style={{ backgroundColor: 'white', border: '1px solid #CBD5E1', color: COLORS.navy }}
                  placeholder="Your company name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: COLORS.navy }}>Message</label>
                <textarea
                  name="message" rows={4} required
                  className="w-full px-4 py-3 rounded-lg resize-none transition-all"
                  style={{ backgroundColor: 'white', border: '1px solid #CBD5E1', color: COLORS.navy }}
                  placeholder="Tell us about your technology challenges and objectives..."
                ></textarea>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  disabled={formState === 'submitting'}
                  className="px-10 py-4 rounded-xl font-semibold text-white transform transition-all duration-300 hover:scale-105 disabled:opacity-60 disabled:hover:scale-100"
                  style={{ background: `linear-gradient(to right, ${COLORS.cantaloupe}, ${COLORS.cantaloupeDark})`, boxShadow: '0 4px 20px rgba(255,130,67,0.3)' }}
                >
                  {formState === 'submitting' ? 'Sending...' : siteContent.contact.buttonText}
                </button>
              </div>
            </form>
          )}
        </Card>
      </div>
    </Section>
  );
};
